import { render } from "./FaqPage.vue?vue&type=template&id=abeda50c"
import script from "./FaqPage.vue?vue&type=script&lang=js"
export * from "./FaqPage.vue?vue&type=script&lang=js"

import "./FaqPage.vue?vue&type=style&index=0&id=abeda50c&lang=css"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__